import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Brand } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
  });
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await register({
        name: form.name.trim(),
        username: form.username.trim().toLowerCase(),
        email: form.email.trim().toLowerCase(),
        password: form.password,
      });
      toast.success(`Welcome to HonestPay, ${r.user.name.split(" ")[0]}!`);
      navigate("/", { replace: true });
    } catch (err) {
      toast.error(errMsg(err, "Could not create account"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="w-full max-w-md hp-glass-strong rounded-[2rem] p-8 hp-fade-in">
        <div className="flex justify-center mb-7">
          <Brand size="lg" to={null} float />
        </div>
        <h1 className="text-2xl font-extrabold text-white text-center">
          Create your account
        </h1>

        <form onSubmit={submit} className="mt-7 space-y-4">
          <div>
            <Label className="text-white">Full name</Label>
            <Input
              data-testid="register-name"
              value={form.name}
              onChange={set("name")}
              placeholder="Jane Doe"
              required
              className="mt-1.5 bg-white/5 border-white/10 text-white"
            />
          </div>
          <div>
            <Label className="text-white">Username</Label>
            <Input
              data-testid="register-username"
              value={form.username}
              onChange={set("username")}
              placeholder="janedoe"
              required
              className="mt-1.5 bg-white/5 border-white/10 text-white"
            />
          </div>
          <div>
            <Label className="text-white">Email</Label>
            <Input
              data-testid="register-email"
              type="email"
              value={form.email}
              onChange={set("email")}
              placeholder="you@example.com"
              required
              className="mt-1.5 bg-white/5 border-white/10 text-white"
            />
          </div>
          <div>
            <Label className="text-white">Password</Label>
            <Input
              data-testid="register-password"
              type="password"
              value={form.password}
              onChange={set("password")}
              placeholder="8+ chars, upper, lower, number, symbol"
              required
              className="mt-1.5 bg-white/5 border-white/10 text-white"
            />
          </div>
          <Button
            data-testid="register-submit"
            type="submit"
            disabled={busy}
            className="hp-cta w-full h-11 rounded-xl font-bold text-white border-0"
          >
            {busy ? "Creating…" : "Create account"}
          </Button>
        </form>

        <p className="text-sm text-muted-foreground text-center mt-6">
          Already have an account?{" "}
          <Link
            to="/login"
            data-testid="to-login"
            className="text-[#c084fc] font-semibold"
          >
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
